// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GZYAp","colMin":"styles_colMin__15jYY"};